var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerSolidSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.6665C14.6023 1.6665 18.3332 5.39734 18.3332 9.99984C18.3332 14.6023 14.6023 18.3332 9.99984 18.3332C5.39734 18.3332 1.6665 14.6023 1.6665 9.99984C1.6665 5.39734 5.39734 1.6665 9.99984 1.6665ZM9.99984 4.99984C9.77882 4.99984 9.56686 5.08763 9.41058 5.24392C9.2543 5.4002 9.1665 5.61216 9.1665 5.83317V9.99984C9.16655 10.2208 9.25438 10.4328 9.41067 10.589L11.9107 13.089C12.0678 13.2408 12.2783 13.3248 12.4968 13.3229C12.7153 13.321 12.9243 13.2334 13.0789 13.0789C13.2334 12.9243 13.321 12.7153 13.3229 12.4968C13.3248 12.2783 13.2408 12.0678 13.089 11.9107L10.8332 9.65484V5.83317C10.8332 5.61216 10.7454 5.4002 10.5891 5.24392C10.4328 5.08763 10.2209 4.99984 9.99984 4.99984Z",
    fill: "#156563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerSolidSvg);
export default __webpack_public_path__ + "static/media/TimerSolidSvg.a78f799d05e44cb56737de5d8355253c.svg";
export { ForwardRef as ReactComponent };